import { ItemView } from './common/CommonComponents';
import { useLanguage } from '../utils/LanguageContext.js';
import { MaritalStatus } from '../shared/constants/userConstants.js';
import { useAuth } from '../utils/AuthContext.js';

const MaritalStatusView = () => {
  const { langForEnum } = useLanguage();
  const { user } = useAuth();

  const items = [
    {
      field: 'maritalStatus',
      value: user.maritalStatus && langForEnum(MaritalStatus, user.maritalStatus),
    },
  ];

  return <ItemView items={items} />;
};

export default MaritalStatusView;
